if (!customElements.get('sensommer-offer')) {
  customElements.define('sensommer-offer', class extends HTMLElement {
    connectedCallback() {
      if (Date.now() >= Date.parse(this.dataset.end)) { this.hidden = true; return; }
      this.querySelector('form').addEventListener('submit', this.addOffer.bind(this));
    }
    async addOffer(event) {
      event.preventDefault();
      const button = this.querySelector('button');
      if (button.disabled) return;
      if (Date.now() >= Date.parse(this.dataset.end)) { this.hidden = true; return; }
      const error = this.querySelector('.so-error');
      error.hidden = true;
      button.disabled = true;
      const drawer = this.closest('cart-drawer');
      const data = new FormData(event.currentTarget);
      if (drawer) {
        data.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
        data.append('sections_url', location.pathname);
      }
      try {
        const response = await fetch(window.routes.cart_add_url + '.js', {method:'POST', body:data, headers:{'X-Requested-With':'XMLHttpRequest'}});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Kunne ikke tilføje opskriften. Prøv igen.');
        if (drawer && result.sections) {
          drawer.renderContents(result);
          if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source:'sensommer-offer',cartData:result});
        } else { location.assign(window.routes.cart_url); }
      } catch (e) {
        error.textContent = e.message;
        error.hidden = false;
      } finally { button.disabled = false; }
    }
  });
}
